/** Editor Supported Format types */
export const FORMAT_TYPES = {
  BOLD: "bold",
  ITALIC: "italic",
  UNDERLINE: "underline",
  STRIKE: "strike_through",
  HEADER: "header",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  LIST: "list",
  UL_LIST: "ul_list",
  OL_LIST: "ol_list",
  CODE: "code_block",
  BLOCKQUOTE: "block_quote",
  LINK: "link",
  COLOR: "color",
  POLL: "poll",
  COLLAGE: "collage",
  EMBED_LINK: "embed_link",
  SHARED_POST: "shared_post",
  MENTION: "Mention",
  CUSTOMBREAK: "custombreak",
  IMAGE: "image",
  VIDEO: "video",
  ERASE: "erase",
  FIELD: "field",
  ALIGN: "align",
  BACKGROUND: "background",
  SCRIPT: "script",
  SUPSCRIPT: "superscript",
  SUBSCRIPT: "subscript",
  HASHTAG: "HashTag",
  MARK: "mark",
  PROPERTY: "property",
  TABLE: "table",
  PARAGRAPH: "paragraph",
  LIST_ITEM: "list_item",
  TEXT: "text",
  JSON: "json"
};

export const ASSIST_FORMAT_TYPES = {
  /** For serializer */
  [FORMAT_TYPES.H1]: 1,
  [FORMAT_TYPES.H2]: 2,
  [FORMAT_TYPES.H3]: 3,
  [FORMAT_TYPES.UL_LIST]: "bullet",
  [FORMAT_TYPES.OL_LIST]: "ordered",

  /** For deserializer */
  1: FORMAT_TYPES.H1,
  2: FORMAT_TYPES.H2,
  3: FORMAT_TYPES.H3,
  bullet: FORMAT_TYPES.UL_LIST,
  ordered: FORMAT_TYPES.OL_LIST
};

export const CUSTOM_TYPES = [
  FORMAT_TYPES.MENTION,
  FORMAT_TYPES.HASHTAG,
  FORMAT_TYPES.POLL,
  FORMAT_TYPES.SHARED_POST,
  FORMAT_TYPES.EMBED_LINK,
  FORMAT_TYPES.COLLAGE,
  FORMAT_TYPES.FIELD,
  FORMAT_TYPES.IMAGE,
  FORMAT_TYPES.VIDEO,
  FORMAT_TYPES.PROPERTY,
  FORMAT_TYPES.TABLE
];

export const CUSTOM_BLOCK_TYPES = [
  FORMAT_TYPES.POLL,
  FORMAT_TYPES.SHARED_POST,
  FORMAT_TYPES.EMBED_LINK,
  FORMAT_TYPES.COLLAGE,
  FORMAT_TYPES.IMAGE,
  FORMAT_TYPES.VIDEO,
  FORMAT_TYPES.TABLE
];

export const LINE_SEPARATOR = "\u2028";

export const TAG_TYPES = {
  P: "p",
  PARAGRAPH: "paragraph",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  STRONG: "strong",
  EM: "em",
  U: "u",
  STRIKE: "strike",
  SUP: "sup",
  SUB: "sub",
  A: "a",
  BLOCKQUOTE: "blockquote",
  PRE: "pre",
  UL: "ul",
  OL: "ol",
  LI: "li",
  DIV: "div",
  TEXT: "text",
  TEXT_HASH: "#text",
  IMAGE: "image",
  VIDEO: "video",
  MENTION: "mention"
};

export const FORMAT_TO_TAG_MAP = {
  [FORMAT_TYPES.PARAGRAPH]: TAG_TYPES.P,
  [FORMAT_TYPES.H1]: TAG_TYPES.H1,
  [FORMAT_TYPES.H2]: TAG_TYPES.H2,
  [FORMAT_TYPES.H3]: TAG_TYPES.H3,
  [FORMAT_TYPES.BOLD]: TAG_TYPES.STRONG,
  [FORMAT_TYPES.ITALIC]: TAG_TYPES.EM,
  [FORMAT_TYPES.UNDERLINE]: TAG_TYPES.U,
  [FORMAT_TYPES.SUBSCRIPT]: TAG_TYPES.SUB,
  [FORMAT_TYPES.SUPSCRIPT]: TAG_TYPES.SUP,
  [FORMAT_TYPES.STRIKE]: TAG_TYPES.STRIKE,
  [FORMAT_TYPES.LINK]: TAG_TYPES.A,
  [FORMAT_TYPES.BLOCKQUOTE]: TAG_TYPES.DIV,
  [FORMAT_TYPES.CODE]: TAG_TYPES.PRE,
  [FORMAT_TYPES.UL_LIST]: TAG_TYPES.LI,
  [FORMAT_TYPES.OL_LIST]: TAG_TYPES.LI
};

export const TAG_TO_FORMAT_MAP = {
  [TAG_TYPES.P]: FORMAT_TYPES.PARAGRAPH,
  [TAG_TYPES.H1]: FORMAT_TYPES.H1,
  [TAG_TYPES.H2]: FORMAT_TYPES.H2,
  [TAG_TYPES.H3]: FORMAT_TYPES.H3,
  [TAG_TYPES.STRONG]: FORMAT_TYPES.BOLD,
  [TAG_TYPES.EM]: FORMAT_TYPES.ITALIC,
  [TAG_TYPES.U]: FORMAT_TYPES.UNDERLINE,
  [TAG_TYPES.STRIKE]: FORMAT_TYPES.STRIKE,
  [TAG_TYPES.SUP]: FORMAT_TYPES.SUPSCRIPT,
  [TAG_TYPES.SUB]: FORMAT_TYPES.SUBSCRIPT,
  [TAG_TYPES.STRIKE]: FORMAT_TYPES.STRIKE,
  [TAG_TYPES.A]: FORMAT_TYPES.LINK,
  [TAG_TYPES.BLOCKQUOTE]: FORMAT_TYPES.BLOCKQUOTE,
  [TAG_TYPES.PRE]: FORMAT_TYPES.CODE,
  [TAG_TYPES.UL]: FORMAT_TYPES.UL_LIST,
  [TAG_TYPES.OL]: FORMAT_TYPES.OL_LIST
};

export const INLINETYPES = [
  FORMAT_TYPES.BOLD,
  FORMAT_TYPES.ITALIC,
  FORMAT_TYPES.UNDERLINE,
  FORMAT_TYPES.STRIKE,
  FORMAT_TYPES.LINK,
  FORMAT_TYPES.COLOR,
  FORMAT_TYPES.SUBSCRIPT,
  FORMAT_TYPES.SUPSCRIPT
];

export const BLOCKLEVELTYPES = [
  FORMAT_TYPES.H1,
  FORMAT_TYPES.H2,
  FORMAT_TYPES.H3,
  FORMAT_TYPES.OL_LIST,
  FORMAT_TYPES.UL_LIST,
  FORMAT_TYPES.BLOCKQUOTE,
  FORMAT_TYPES.CODE
];

export const ASSIST_GROUP_TYPE = {
  [FORMAT_TYPES.UL_LIST]: "ul",
  [FORMAT_TYPES.OL_LIST]: "ol",
  [FORMAT_TYPES.BLOCKQUOTE]: "blockquote",
  [FORMAT_TYPES.CODE]: "div"
};

export const ATTRIBUTE_ORDER = [
  FORMAT_TYPES.LINK,
  FORMAT_TYPES.COLOR,
  FORMAT_TYPES.STRIKE,
  FORMAT_TYPES.UNDERLINE,
  FORMAT_TYPES.ITALIC,
  FORMAT_TYPES.BOLD,
  FORMAT_TYPES.SUBSCRIPT,
  FORMAT_TYPES.SUPSCRIPT
];

export const GROUP_TYPES = [
  FORMAT_TYPES.UL_LIST,
  FORMAT_TYPES.OL_LIST,
  FORMAT_TYPES.BLOCKQUOTE,
  FORMAT_TYPES.CODE
];
